import CloseIcon from "@mui/icons-material/Close";
import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Typography,
  useTheme,
} from "@mui/material";
import { useTranslation } from "react-i18next";

const LocationWarningModal = (props) => {
  const { t } = useTranslation();
  const { open, onClose } = props;
  const theme = useTheme();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="sm"
      id="infoModal"
      className="info-modal"
      BackdropProps={{
        style: {
          backdropFilter: "blur(5px)",
          backgroundColor: "rgba(0, 0, 0, 0.4)",
        },
      }}
    >
      <DialogTitle
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1,
          backgroundColor: theme.palette.background.paper,
          color: theme.palette.text.primary,
        }}
      >
        <Typography
          variant="h6"
          component="h3"
          sx={{ flexGrow: 1, color: "#ED1D51" }}
        >
          {t('appModals.locationWarningTitle')}
        </Typography>
        <IconButton
          aria-label={t('appModals.locationWarningCloseAriaLabel')}
          onClick={onClose}
          sx={{ color: theme.palette.grey[500] }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <hr />
      <DialogContent
        sx={{
          backgroundColor: theme.palette.background.paper,
          color: theme.palette.text.primary,
        }}
      >
        <Grid container spacing={2}>
          <Box borderRadius={2} p={{ xs: 1, sm: 1 }} gap={2} sx={{ mb: 3 }}>
            <Typography
              fontWeight={400}
              fontSize={{ xs: "0.875rem", sm: "1rem" }}
            >
              {t('appModals.locationWarningIntro')}
              <ul style={{ margin: 0, paddingLeft: 18 }}>
                {/* <li>Canada: Ontario, Quebec</li> */}
                <li>
                  {t('appModals.locationWarningUsJurisdictions')}
                </li>
              </ul>
            </Typography>
          </Box>
        </Grid>
      </DialogContent>
    </Dialog>
  );
};

export default LocationWarningModal;
